import { useApiQuery } from 'grabbitbot-legacy-ui'
import { screenerClient } from '../../api'

/** Equivalent of legacy `AdminUsageStatComponent` (audit §3/§4 — global
 * hourly usage). Legacy backend response shape isn't a fixed contract in
 * the audit (its own model was loosely typed too) — rendered as raw JSON
 * rather than guessing a chart shape the FastAPI rewrite may not match. */
export function AdminUsagePage() {
  const { data, loading, error } = useApiQuery(() => screenerClient.admin.hourlyUsage(), [])

  return (
    <div>
      <h1>Admin — usage</h1>
      {loading && <p>Loading…</p>}
      {error && <p role="alert">Could not load usage statistics.</p>}
      {data != null && <pre>{JSON.stringify(data, null, 2)}</pre>}
    </div>
  )
}
